import { render, staticRenderFns } from "./KimsaDrawer.vue?vue&type=template&id=1c5decb6&scoped=true&"
import script from "./KimsaDrawer.vue?vue&type=script&lang=js&"
export * from "./KimsaDrawer.vue?vue&type=script&lang=js&"
import style0 from "./KimsaDrawer.vue?vue&type=style&index=0&id=1c5decb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5decb6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListGroup } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VDivider,VIcon,VList,VListGroup,VListItem,VListItemAvatar,VListItemIcon,VListItemTitle,VNavigationDrawer,VSubheader})
